import xss from 'xss'

import { nl2br, stripHTMLTags } from 'utils/text'

export function sanitizeAndFormatHTML(htmlString: string, shouldStrip = true) {
  return nl2br(stripHTMLTags(xss(htmlString), shouldStrip))
}
